import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Type } from '@spotify-internal/encore-creator-web';
import styles from './index.module.scss';
import {
  LOADING,
  ERROR,
  selectEpisodeListeners,
  selectEpisodeListenersStatus,
  selectDateRange,
} from '../../../store/selectors';
import { loadEpisodeListeners } from '../../../store/episodeListeners';
import { PerformanceOverTimeChart } from '../../../components/Shared/Charts/PerformanceOverTimeChart';
import { LoadingIndicator } from '../../../components/Shared/LoadingIndicator';
import { ReduxState, DateRangeWithLabel, Listener } from '../../../types';
import { FormattedMessage } from 'react-intl';

type Props = {
  episodeId: string;
  listeners?: Listener[];
  status?: 'LOADING' | 'ERROR';
  dateRange?: DateRangeWithLabel;
  loadEpisodeListeners: typeof loadEpisodeListeners;
};

class EpisodeListeners extends PureComponent<Props> {
  componentDidMount() {
    this.props.loadEpisodeListeners(this.props.episodeId);
  }

  /* istanbul ignore next */
  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    if (!this.props.dateRange || !nextProps.dateRange) return;

    if (
      nextProps.dateRange.startDate !== this.props.dateRange.startDate ||
      nextProps.dateRange.endDate !== this.props.dateRange.endDate
    ) {
      this.props.loadEpisodeListeners(this.props.episodeId);
    }
  }

  render() {
    const { status, listeners } = this.props;

    if (status === ERROR) {
      return <span data-qa="episode-listeners-error" />;
    }

    if (!listeners && status !== LOADING) {
      return null;
    }

    return (
      <div data-qa="episode-listeners-chart" className={styles.container}>
        <Type as="h1" variant={Type.heading3}>
          <FormattedMessage id="episode.listeners.title" defaultMessage="Listeners" />
        </Type>
        {status === LOADING ? (
          <div style={{ width: '100%', height: '350px' }}>
            <LoadingIndicator />
          </div>
        ) : (
          <PerformanceOverTimeChart performanceData={this.props.listeners!} name="Listeners" />
        )}
      </div>
    );
  }
}

function mapStateToProps(state: ReduxState) {
  return {
    status: selectEpisodeListenersStatus(state),
    listeners: selectEpisodeListeners(state),
    dateRange: selectDateRange(state),
  };
}

const actions = {
  loadEpisodeListeners,
};

export const ConnectedEpisodeListeners = connect(mapStateToProps, actions)(EpisodeListeners);
